import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  getAllFinishedProducts,
  getAllRawSemiProducts,
  getBOMbyId,
  addBOMProduct,
  getBOMCompbyId,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddProduct.css";

const AddEditBOM = () => {
  const { currentColor, storeG, defaultImageMode, imageMode, userObj } =
    useStateContext();
  const navigate = useNavigate();

  const [CardList, setcartList] = useState([]);
  const [productName, setProductName] = useState("");
  const [productId, setProductId] = useState("");
  const [revision, setRevision] = useState("");
  const [effDate, setEffDate] = useState("");
  const [active, setActive] = useState(0);
  const [notes, setNotes] = useState("");
  const [ValError, setValError] = useState([]);
  const [Products, setProducts] = useState([]);
  const [Product, setProduct] = useState("select");
  const [RProducts, setRProducts] = useState([]);
  const [RProduct, setRProduct] = useState("select");
  const [quantity, setQuantity] = useState("");
  const [scrap, setScrap] = useState("");
  const [itemNotes, setItemNotes] = useState("");
  let param = useParams();
  const Bom_id = param.bom_id || 0;

  const [formData, setFormData] = useState({
    bom_id: "",
    parent_id: "",
    revision: "",
    eff_date: "",
    active: false,
    bom_notes: "",
    assign_products: [],
  });

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      navigate("/BOMs");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteClick = (index) => {
    TimeoutUtility.resetTimeout();
    const remProd = CardList[index];
    if (window.confirm(`Do you want to remove ${remProd.code} from BOM?`)) {
      const newCartList = [...CardList];
      newCartList.splice(index, 1);
      setcartList(newCartList);
    }
  };

  const handleAddcartClick1 = () => {
    try {
      setValError([]);
      const updatedErrors = [...ValError];

      if (RProduct === "select" || RProduct === "Select Product") {
        updatedErrors[4] = "Please select Raw Product.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[4] = "";

      if (quantity === "") {
        updatedErrors[5] = "Please enter quantity!";
        setValError(updatedErrors);
        return;
      }
      if (quantity <= 0) {
        updatedErrors[5] = "Quantity must be greater than 0!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[5] = "";

      if (scrap === "") {
        updatedErrors[6] = "Please enter scrap!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[6] = "";

      const rawProd = RProducts.find(
        (item) => `${item.code} - ${item.productname}` === RProduct
      );

      const updatedItem = [...CardList];
      const defaultProduct = {
        product_id: rawProd.product_id,
        name: rawProd.productname,
        code: rawProd.code,
        image: rawProd.image,
        image_url: rawProd.image_url,
        unit: rawProd.unit,
        qty: quantity,
        scrap: scrap,
        notes: itemNotes,
      };
      setcartList([defaultProduct, ...updatedItem]);
      setRProduct("");
      setQuantity("");
      setScrap("");
      setItemNotes("");
    } catch (err) {}
  };

  const handleSaleOrderClick = async (e) => {
    try {
      const { user_id, user_token } = userObj;

      if (CardList.length === 0) {
        alert("No product to assign.");
        return;
      }
      setValError([]);
      const updatedErrors = [...ValError];

      if (
        Bom_id === 0 &&
        (Product === "select" || Product === "Select Product")
      ) {
        updatedErrors[0] = "Please select Finished Product!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (revision === "") {
        updatedErrors[1] = "Please enter revision!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[1] = "";

      if (effDate === "") {
        updatedErrors[2] = "Please enter Effective Date!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";

      const finProd = Products?.find(
        (item) => `${item.code} - ${item.productname}` === Product
      );

      const updatedFormData = { ...formData };
      updatedFormData.bom_id = Bom_id;
      updatedFormData.parent_id = Bom_id === 0 ? finProd.product_id : productId;
      updatedFormData.revision = revision;
      updatedFormData.eff_date = effDate.replace("T", " ");
      updatedFormData.active = active;
      updatedFormData.bom_notes = notes;
      updatedFormData.store_id = storeG.store_id;
      updatedFormData.assign_products = [];

      CardList.forEach((product) => {
        const saleProduct = {
          product_id: product.product_id,
          quantity: product.qty,
          scrap: product.scrap,
          notes: product.notes,
        };
        updatedFormData.assign_products.push(saleProduct);
      });

      setFormData(updatedFormData);
      console.log(updatedFormData);
      const response = await addBOMProduct(
        updatedFormData,
        user_id,
        user_token
      );
      if (response.status === 200) {
        alert("Product assigned successfully.");
      } else {
        alert("Product Fail to assign.");
        return;
      }
      window.location.reload();
    } catch (err) {}
  };

  const handleChangeProduct = (e) => {
    setProduct(e.target.value);
    if (e.target.value !== "select") {
      const updatedErrors = [...ValError];
      updatedErrors[0] = "";
      setValError(updatedErrors);
    }
  };

  const handleChangeRProduct = (e) => {
    setRProduct(e.target.value);
    if (e.target.value !== "select") {
      const updatedErrors = [...ValError];
      updatedErrors[4] = "";
      setValError(updatedErrors);
    }
  };

  const handleChangeODateTime = (e) => {
    if (e === "undefined") {
      setEffDate(null);
    } else {
      setEffDate(e);
    }
  };

  const handleChangeActive = (e) => {
    setActive((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeRevision = (e) => {
    setRevision(e.target.value);
  };

  const handleChangeNotes = (e) => {
    setNotes(e.target.value);
  };

  const handleChangeItemNotes = (e) => {
    setItemNotes(e.target.value);
  };

  const handleChangeQuantity = (e) => {
    setQuantity(e.target.value);
  };

  const handleChangeScrap = (e) => {
    setScrap(e.target.value);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  useEffect(() => {
    async function fetchData() {
      if (userObj && storeG) {
        const { user_id, user_token } = userObj;
        if (Bom_id && Bom_id !== 0) {
          await getBOMbyId(Bom_id, user_id, user_token)
            .then(function (result) {
              setProductName(result.data[0].pname);
              setProductId(result.data[0].product_id);
              setRevision(result.data[0].revision);
              setActive(result.data[0].is_active);
              setNotes(result.data[0].notes);
              if (result.data[0].effective_from !== null) {
                const dbDate = new Date(result.data[0].effective_from);
                dbDate.setUTCHours(24);
                setEffDate(dbDate.toISOString().split("T")[0]);
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
          await getBOMCompbyId(Bom_id, user_id, user_token).then(function (
            result
          ) {
            if (result.data) {
              const productList = result.data.map((item) => ({
                product_id: item.product_id,
                name: item.productname,
                code: item.code,
                image: item.image,
                image_url: item.image_url,
                unit: item.unit,
                qty: item.quantity,
                scrap: item.scrap_percentage,
                notes: item.notes,
              }));
              setcartList(() => [...productList]);
            }
          });
        } else {
          getAllFinishedProducts(storeG.store_id, user_id, user_token)
            .then((resp) => {
              setProducts(resp.data || []);
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
        getAllRawSemiProducts(storeG.store_id, user_id, user_token)
          .then((resp) => {
            setRProducts(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [Bom_id, userObj, storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title={Bom_id !== 0 ? "UPDATE BOM" : "CREATE BOM"} />
      <Container
        fluid="true"
        className="g-0 p-0 justify-end"
        style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
      >
        <Row xs={1} sm={1} style={{ paddingLeft: "10px" }}>
          <Col md={6} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label" htmlFor="ProductSelect">
                  Finished Good:
                </label>
                <select
                  id="ProductSelect"
                  className="select container-select"
                  value={Product}
                  onChange={handleChangeProduct}
                  disabled={Bom_id !== 0}
                >
                  <option defaultValue="select">
                    {Bom_id !== 0 ? productName : `Select Product`}
                  </option>
                  {Products.map((item) => (
                    <option key={item.product_id}>
                      {item.code} - {item.productname}
                    </option>
                  ))}
                </select>
                <span className="label-imp">*</span>
                {ValError[0] && <p className="label-error">{ValError[0]}</p>}
              </div>
            </div>
          </Col>
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Revision:</label>
                <input
                  type="text"
                  name="revision"
                  value={revision}
                  placeholder="Revision"
                  className="input"
                  onChange={handleChangeRevision}
                />
                <span className="label-imp">*</span>
                {ValError[1] && <p className="label-error">{ValError[1]}</p>}
              </div>
            </div>
          </Col>
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Effective Date:</label>
                <input
                  className="input"
                  id="o_date"
                  type="date"
                  value={effDate}
                  onChange={(e) => handleChangeODateTime(e.target.value)}
                />
                <span className="label-imp">*</span>
                {ValError[2] && <p className="label-error">{ValError[2]}</p>}
              </div>
            </div>
          </Col>
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Active:</label>
                <input
                  type="checkbox"
                  value="ActiveProduct"
                  checked={active === 1}
                  onChange={handleChangeActive}
                />
                <span className="label-imp">*</span>
              </div>
            </div>
          </Col>
          <Col md={12} className="container-col mt-2">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Notes:</label>
                <input
                  type="text"
                  name="notes"
                  value={notes}
                  placeholder="Notes"
                  className="input"
                  style={{ width: "90%" }}
                  onChange={handleChangeNotes}
                />
                {ValError[3] && <p className="label-error">{ValError[3]}</p>}
              </div>
            </div>
            <br />
          </Col>
          <Col md={12} className="container-col mt-2">
            <label className="label" style={{ fontSize: "24px" }}>
              BOM ITEMS:
            </label>
          </Col>
          <Col md={6} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label" htmlFor="ProductSelect">
                  Raw Material:
                </label>
                <select
                  id="ProductSelect"
                  className="select container-select"
                  value={RProduct}
                  onChange={handleChangeRProduct}
                >
                  <option defaultValue="select">Select Product</option>
                  {RProducts.map((item) => (
                    <option key={item.product_id}>
                      {item.code} - {item.productname}
                    </option>
                  ))}
                </select>
                <span className="label-imp">*</span>
                {ValError[4] && <p className="label-error">{ValError[4]}</p>}
              </div>
            </div>
          </Col>
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Quantity:</label>
                <input
                  type="number"
                  min="0"
                  step="1.00"
                  name="Quantity"
                  onChange={handleChangeQuantity}
                  value={quantity}
                  placeholder="Quantity"
                  className="input"
                />
                <span className="label-imp">*</span>
                {ValError[5] && <p className="label-error">{ValError[5]}</p>}
              </div>
            </div>
          </Col>
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Scrap %:</label>
                <input
                  type="number"
                  min="0"
                  max="99"
                  step="1.00"
                  name="Scrap"
                  onChange={handleChangeScrap}
                  value={scrap}
                  placeholder="Scrap %"
                  className="input"
                />
                <span className="label-imp">*</span>
                {ValError[6] && <p className="label-error">{ValError[6]}</p>}
              </div>
            </div>
          </Col>
          <Col md={9} className="container-col mt-2">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Item Notes:</label>
                <input
                  type="text"
                  name="notes"
                  value={itemNotes}
                  placeholder="Notes"
                  className="input"
                  style={{ width: "90%" }}
                  onChange={handleChangeItemNotes}
                />
                {ValError[7] && <p className="label-error">{ValError[7]}</p>}
              </div>
            </div>
            <br />
          </Col>
          <Col md={1} className="container-col mt-2">
            <Button
              margin="10px"
              padding="20px"
              color="white"
              className="custom-button"
              bgColor={currentColor}
              text="Add"
              borderRadius="10px"
              onClick={handleAddcartClick1}
              // disabled={loadBtn}
            />
          </Col>
          <Col md={11}>
            <Row
              xs={1}
              sm={1}
              className="justify-content-center table-container-sale"
              style={{ height: "34vh" }}
            >
              <div className="m-0 p-0">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="table-sale-tr">
                      <th style={{ width: "50px" }}>CODE</th>
                      <th style={{ width: "260px" }}>PRODUCT</th>
                      <th style={{ width: "50px" }}>UNIT</th>
                      <th style={{ width: "60px" }}>QTY</th>
                      <th style={{ width: "60px" }}>SCRAP %</th>
                      <th style={{ width: "60px" }}>NOTES</th>
                      <th style={{ width: "35px" }}>DEL</th>
                    </tr>
                  </thead>
                  <tbody className="pos-table-body">
                    {CardList?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.code}</td>
                        <td>
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {defaultImageMode &&
                              imageMode &&
                              (item.image || item.image_url) && (
                                <div
                                  className="image flex gap-4"
                                  style={{
                                    maxWidth: "72px",
                                    maxHeight: "72px",
                                    flex: "0 0 20%",
                                  }}
                                >
                                  <img
                                    className="rounded-xl"
                                    src={
                                      item.image_url
                                        ? `${item.image_url}`
                                        : `data:image/jpeg;base64,${item.image}`
                                    }
                                    alt={`Product ${item.code}`}
                                  />
                                </div>
                              )}
                            <div
                              style={{
                                flex:
                                  defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                    ? "0 0 80%"
                                    : "0 0 100%",
                                paddingTop:
                                  !(
                                    defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                  ) && "8px",
                                paddingBottom:
                                  !(
                                    defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                  ) && "7px",
                                alignSelf: "center",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {truncate(
                                  item.name,
                                  defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                    ? 42
                                    : 48
                                )}
                              </div>
                              {/* <div>
                                {truncate(
                                  item.details,
                                  defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                    ? 96
                                    : 120
                                )}
                              </div> */}
                            </div>
                          </div>
                        </td>
                        <td>{item.unit}</td>
                        <td>{item.qty}</td>
                        <td>{item.scrap}</td>
                        <td>{item.notes}</td>
                        <td>
                          <button onClick={() => handleDeleteClick(index)}>
                            ❌
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Assign"
          borderRadius="10px"
          onClick={handleSaleOrderClick}
          // disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditBOM;
